import Model from '@/lib/data/Model';

class CustomerGroup extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'icon_index',
        'is_owner',
        'name',
        'shared',
        'state',
        'organization_id',
        'tenant_id',
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }
}

export default CustomerGroup;
